import { IWindowInfo } from "../../model/custom/ILayout";

export class CollapseSidebarAction {
	static readonly type = "[Layout] Collapse Sidebar";
}

export class ExpandSidebarAction {
	static readonly type = "[Layout] Expand Sidebar";
}

/*
 * Show / hide sidebar
 * */
export class ToggleSidebarAction {
	static readonly type = "[Layout] Toggle Sidebar";
	constructor(public payload: boolean) {}
}

export class UpdateWindowInfoAction {
	static readonly type = "[Layout] Update Window Params Action";
	constructor(public payload: IWindowInfo) {}
}
